/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          wasteWaterType: {
            type: 'string',
            enum: ['HAZARDOUS_WASTEWATER', 'NON-HAZARDOUS_WASTEWATER', 'UNKNOWN'],
          },
          wastewaterTreatment: {
            type: 'string',
            enum: [
              'BOTH_ONSITE_OFFSITE_TREATMENT',
              'MUNICIPAL/PUBLIC_SEWER_SYSTEMS',
              'NO_TREATMENT',
              'OFF-SITE_WATER_TREATMENT',
              'ON-SITE_PARTIAL_RECLAMATION',
              'ON-SITE_WATERSHED_MANAGEMENT',
              "REUSE/RECYCLE_IN_ORGANIZATION'S_OWN_OPERATIONS",
              'UNKNOWN',
              'ZERO_LIQUID_DISCHARGE',
            ],
          },
          treatmentEfficiency: {
            type: 'string',
            enum: ['AVERAGE_TREATMENT_EFFICIENCY', 'HIGH_TREATMENT_EFFICIENCY', 'NO_TREATMENT/LOW_EFFICIENCY'],
          },
          unit: {
            type: 'string',
            enum: ['CUBIC_METRE'],
          },
          totalAnnualVolume: {
            type: 'number',
          },
          contaminationLevel: {
            type: 'number',
          },
          year: {
            type: 'number',
            minimum: 1000,
            maximum: 9000,
          },
        },
        required: ['wasteWaterType', 'wasteWaterTreatment', 'treatmentEfficiency', 'year', 'unit', 'totalAnnualVolume'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    waste_water_treatment_proficiency: valueSchema,
  },
}
